import { MKT_STATUS_TYPE } from 'helpers/marketplaceStatus';

const getSoldOfferStatus = ({ vehicle, currentUserTopOfferer }) => {
	const { my_offer_amount } = vehicle;
	const currentUserHasOffered = !!my_offer_amount;
	return currentUserTopOfferer ?
			{ unifiedStatusType: MKT_STATUS_TYPE.won }
		:	{ unifiedStatusType: currentUserHasOffered ? MKT_STATUS_TYPE.lost : MKT_STATUS_TYPE.sold };
};

export default getSoldOfferStatus;
